module.exports = __webpack_public_path__ + "img/sys6.2a3acc84.png";